import { erpAxios } from '.';

const getStatusOdbijenRazlozi = async () => {
  const { data } = await erpAxios.get('statusOdbijen/razlozi');
  return data;
};

export default getStatusOdbijenRazlozi;
